import { render, staticRenderFns } from "./RomaOa.vue?vue&type=template&id=4fbde0fe"
import script from "./RomaOa.vue?vue&type=script&lang=ts"
export * from "./RomaOa.vue?vue&type=script&lang=ts"
import style0 from "./RomaOa.vue?vue&type=style&index=0&id=4fbde0fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports